<template>
	<div>
		<el-form label-width="120px" style="padding-top: 10px;" :model="dataForm"  ref="dataForm" :rules="dataRule">
			<el-row>
				<el-col :sm="24" :lg="24">
					<el-form-item label="任务大类:" prop="ticketProject">
						<!-- <el-input style="width: 80%;" placeholder="任务大类" v-model="formData.ticketProject" disabled></el-input> -->
						{{formData.ticketProject}}
					</el-form-item>
				</el-col>
				<el-col :sm="12" :lg="12">
					<el-form-item label="业务月体量" prop="monthlyVolume">
						<el-input style="width: 91%;" v-model="dataForm.monthlyVolume" placeholder="预计业务月体量:【】万元" :disabled="isStatusDis" ></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :sm="12" :lg="12">
					<el-form-item label="任务场景" prop="businessScenario">
						<el-input rows="6" maxlength="500" v-model="dataForm.businessScenario" show-word-limit type="textarea" :disabled="isStatusDis"  placeholder="前面填公司所属行业,后面填用工场景:如市场推广、软件开发、信息服务、会议会展服务等" style="border: none;width: 91%;"></el-input>
					</el-form-item>
				</el-col>
				<el-col :sm="12" :lg="12">
					<el-form-item label="结算价格及计算方式" prop="taskRequire">
						<el-input rows="6" maxlength="500" v-model="dataForm.taskRequire" show-word-limit type="textarea" :disabled="isStatusDis"  placeholder="按项目内容,填写结算依据,例如:市场推广;基础服务结算200元/天,线下活动和品牌推广按1千-8千/次(按规模)" style="border: none;width: 91%;"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
	</div>
</template>

<script>
export default{
	props:['formData','isStatusDis'],
	data(){
		return{
			dataForm:{
				businessScenario:'',//任务场景
				monthlyVolume:'',//业务月体量
				taskRequire:'',//结算及计算方式
			}
		}
	},
	computed:{
		dataRule(){
			return{
				businessScenario:[{required: true,message: this.$t('validate.required'),trigger: 'blur'}],
				monthlyVolume:[{required: true,message: this.$t('validate.required'),trigger: 'blur'}],
				taskRequire:[{required: true,message: this.$t('validate.required'),trigger: 'blur'}],
			}
		}
	},
	created(){
		console.log(this.formData)
		this.dataForm = {...this.dataForm,...this.formData}
	}
}

</script>
<style lang="scss">

</style>